export enum SaveType {
  SaveChanges,
  SaveAndUpgradeStatus,
  ConfirmResults,
  RejectResults,
  ConfirmRequest,
  RejectRequest,
  CancelRequest
}
